// extracted by mini-css-extract-plugin
export var downArrow = "_ah-0";
export var label = "_ah-1";
export var treatmentCard = "_ah-3";
export var upArrow = "_ah-2";